import React from "react";

export const CartProductOptions = (options) => {
  if (!options || options.length === 0) return null;
  return (
    <>
      {options.map((option, index) => (
        <p key={index}>
          {option.name}: {option.value}
        </p>
      ))}
    </>
  );
};
